import React, {useEffect, useState} from 'react';
import Header from "../../components/Header";
import FooterOrder from "../../components/FooterOrder";
import OrderIdle from "../../components/OrderIdle";
import {useTranslation} from "react-i18next";
import "./style.scss";
import {getEatInSettings} from "../../helpers/ApiHelper";
import orderStore from "../../stores/order";
import TableFilter from "../../components/TableFilter";
import NumInput from "../../components/NumInput";

const TableNumberPage = () => {
    const [t] = useTranslation();

    const [selected, setSelected] = useState<number>(-1);
    const [filter, setFilter] = useState<string>("");

    useEffect(() => {
        orderStore.setTableNumber(selected);
    }, [selected]);

    const getPredefinedTables = (): number[] => {
        const setting = getEatInSettings();
        if (!setting) return [];

        return setting.predefinedKitchenNumbers || [];
    }

    return <div className="TableNumberPage">
        <Header/>
        <div className="pageContent">
            <h2>{t('chooseTable')}</h2>
            {getEatInSettings()?.commentToManualKitchenNumbers
                ? <div className="description">{getEatInSettings()?.commentToManualKitchenNumbers}</div>
                : null
            }
            {getPredefinedTables().length > 30
                ? <TableFilter onChange={(f) => setFilter(f)} />
                : null
            }
            <div className="tables">
                {getEatInSettings()?.predefinedKitchenNumbers.length
                    ? Array.from(new Set<number>(getEatInSettings()?.predefinedKitchenNumbers || [])).sort((a, b) => a-b).filter(x => !filter.length || x.toString().includes(filter)).map(x => <div key={`table_${x}`} className={`table ${selected === x ? "selected" : ""}`} onClick={() => setSelected(x)}>{x}</div>)
                    : <NumInput onChange={(x) => setSelected(parseInt(x, 10) > 0 ? parseInt(x, 10) : -1)} />
                }
            </div>
        </div>
        <FooterOrder canContinue={selected > -1} />
        <OrderIdle />
    </div>
}

export default TableNumberPage;
